







import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class WebAssistantViewToggle extends Vue {
	@Prop() public activeView: 'homescreen' | 'conversation';

	public setActiveView(view: 'homescreen' | 'conversation') {
		this.$emit('viewChange', view);
	}
}
